import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux'

import {
  fetchUserStatus,
  selectUserStatus
} from '../../../../../slices/userStatus'
import useStyles from './styles'

const DEFAULT_STATUS = 'No Status'

const ClientStatus = ({ client }) => {
  const dispatch = useAppDispatch()
  const { loaded, loading, statuses } = useAppSelector(selectUserStatus)

  const [status, setStatus] = React.useState(null)

  const classes = useStyles({ colour: status?.colour })

  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchUserStatus())
    }
  }, [dispatch, loaded, loading])

  React.useEffect(() => {
    if (loaded) {
      const foundStatus = statuses.find(
        status => status.id === client.status_id
      )
      setStatus(foundStatus)
    }
  }, [loaded, statuses, client.status_id])

  if (!status) return <div className={classes.root}>{DEFAULT_STATUS}</div>

  return (
    <div className={classes.foundRoot}>
      <div className={classes.dot} />
      <label>{status?.name}</label>
    </div>
  )
}

export default ClientStatus
